import  FetchData, { } from '../../client';
import {getBranchId, getHospitalId, getLoginID}  from '../../../auth';
import formAPIModelDoctorFavLabs from '../../domains/doctorfavourite/labs/labs';

//reac the file

  const GetDoctorFavLab = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.clinicid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_getdoctorfavlab", inputData);
      // console.log(result, " DB result of get Fav Labs")
      if(result.output.message){
        return result
      }else if(result.output.data) {
      var data = formAPIModelDoctorFavLabs(result.output.data)
      let count = result?.output?.count;
      let pageno  = result?.output?.pageno;
      let pagesize =  result?.output?.pagesize;
    var finalOutput = {
        data,
        count,
        pageno,
        pagesize
    }
      return finalOutput;
      }
      
    } catch (error) {
      console.error("Error fetching data in GetDoctorFavLab :", error);
      throw error;
    }
  };
  const AddDoctorFavLab = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.clinicid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_adddoctorfavlab", inputData);
     
      return result;
    } catch (error) {
      console.error("Error fetching data in AddDoctorFavLab :", error);
      throw error;
    }
  };
  const UpdateDoctorFavLab = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_updatedoctorfavlab", inputData);
     
      return result;
    } catch (error) {
      console.error("Error fetching data in UpdateDoctorFavLab :", error);
      throw error;
    }
  };
  const DeleteDoctorFavLab = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_deletedoctorfavlab", inputData);
     
      return result;
    } catch (error) {
      console.error("Error fetching data in deletedoctorfavlab :", error);
      throw error;
    }
  };
export {GetDoctorFavLab, AddDoctorFavLab,UpdateDoctorFavLab, DeleteDoctorFavLab};
